// Copyright: IQGeo Limited 2010-2019
// base myWorld code to be used in pages such as config and home
// also defines what goes into myWorld-base.min.js
import myw from 'myWorld/base/core';
import 'myWorld/base/errors';
import 'myWorld/base/util';
import 'myWorld/base/config';
import 'myWorld/base/localisation';
import 'myWorld/base/view';
import 'myWorld/base/control';
import 'myWorld/base/plugin';
import 'myWorld/base/pluginButton';
import 'myWorld/base/viewManager';
import 'myWorld/base/unitScale';
import 'myWorld/base/semaphore';
import 'myWorld/base/svgRenderer';
import 'myWorld/base/usageMonitor';

export default myw;
